<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :footer="footer"
    :methods="methods"
    :config="config"
    @getList="getList"
  >
    <template #componentContainer>
      <order-tracker ref="showSatus" :statusId="statusId"></order-tracker>
    </template>
  </cTable>
</template>

<script>
import { getReceive } from "@/api/analysis/receivable";
import { getAgent } from "@/api/tracker/agent";
import orderTracker from "@/base/tracker";
import cTable from "@/base/common/index";
// import format from "@/utils/format";
// import expandRow from "_my/table-expand";
export default {
  name: "receivableReport",
  components: {
    cTable,
    orderTracker
  },
  methods: {
    getList(res) {
      this.fields.forEach(field => {
        if (field.key === "receivableSummary") {
          field.name =
            res.searchForm["startTime"] +
            "~" +
            res.searchForm["endTime"] +
            this.$t("ReceivableSummary");
        }
      });
      // console.log(res);
    }
  },
  data() {
    return {
      statusId: "",
      methods: {
        list: getReceive,
        getAgent
      },
      config: {
        height: 630,
        merge: true
      },
      footer: { show: () => false },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            default() {
              return this.$page.format.dateFormat(
                new Date().setDate(1),
                "yyyy-MM-dd"
              );
            },
            bind: {
              clearable: false,
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            default() {
              return this.$page.format.dateFormat(new Date(), "yyyy-MM-dd");
            },
            bind: {
              clearable: false,
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
              // "on-change"({ searchForm }) {
              //   let time = this.$page.format.timeFormat(searchForm.endTime);
              //   if (time.slice(-8) === "00:00:00") {
              //     time = time.split(" ")[0] + " " + "23:59:59";
              //     searchForm.endTime = time;
              //   }
              // }
            }
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getAgent")
                ).payload.rows;
                this.$forceUpdate();
              }
            },
            config: { label: "agent_name", value: "id" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              // console.log(this);
              let data = this.$refs["header"].searchForm;
              console.log(this.$refs["header"].searchForm);
              data["export"] = 1;
              data["startTime"] = this.format.dateFormat(
                data["startTime"],
                "YYYY-MM-DD"
              );
              data["endTime"] = this.format.dateFormat(
                data["endTime"],
                "YYYY-MM-DD"
              );
              this.openLoading();
              this.handleRequestMethods("list", data, false, true).then(res => {
                // console.log("res", res);
                window.open(this.$globalUrl + res.payload.src);
              });
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$t("ReceivableSummary"),
          key: "receivableSummary",
          align: "center",
          children: [
            // {
            //   name: () => this.$t("serialNumber"),
            //   type: "seq",
            //   align: "center",
            //   width: 60
            // },
            {
              name: () => this.$t("target_country"),
              key: "country",
              align: "center",
              minWidth: 60
            },
            {
              name: () => this.$t("SetOriginalCurrency"),
              key: "currency",
              align: "center",
              minWidth: 80
            },
            {
              name: () => this.$t("agentName"),
              key: "agent",
              align: "center",
              minWidth: 100
            },
            {
              name: () => this.$t("Billed"),
              key: "Billed",
              align: "center",
              children: [
                {
                  name: () => this.$t("Votes"),
                  key: "bill_count",
                  align: "center",
                  minWidth: 80
                },
                {
                  name: () => this.$t("HandlingFee") + "USD",
                  key: "bill_charge",
                  align: "center",
                  minWidth: 100
                },
                {
                  name: () => this.$t("OriginalCurrency"),
                  key: "bill_cod",
                  align: "center",
                  minWidth: 100
                },
                {
                  name: () => this.$t("ConvertedUdollars"),
                  key: "convertedUdollars",
                  align: "center",
                  children: [
                    {
                      name: () => this.$t("WrittenOff"),
                      key: "bill_confirm_usd",
                      align: "center",
                      minWidth: 100
                    },
                    {
                      name: () => this.$t("NotWrittenOff"),
                      key: "bill_no_confirm_usd",
                      align: "center",
                      minWidth: 100
                    }
                  ]
                }
              ]
            },
            {
              name: () =>
                this.$t("Unbilled") + "(" + this.$t("PodAlready") + ")",
              key: "Unbilled",
              align: "center",
              children: [
                {
                  name: () => this.$t("Votes"),
                  key: "not_bill_count",
                  align: "center",
                  minWidth: 80
                },
                {
                  name: () => this.$t("OriginalCurrency"),
                  key: "not_bill_cod",
                  align: "center",
                  minWidth: 100
                },
                {
                  name: () => this.$t("MaintainExchangeRate") + "(USD)",
                  key: "not_bill_rate",
                  align: "center",
                  minWidth: 80
                },
                {
                  name: () => this.$t("ConvertedUdollars"),
                  key: "not_bill_usd",
                  align: "center",
                  minWidth: 100
                }
              ]
            },
            {
              name: () => this.$t("TotalReceivable"),
              key: "totalReceivable",
              align: "center",
              children: [
                {
                  name: () => this.$t("OriginalCurrency") + "COD",
                  key: "all_cod",
                  align: "center",
                  minWidth: 100
                },
                {
                  name: () => this.$t("ConvertedUdollars"),
                  key: "all_usd",
                  align: "center",
                  minWidth: 100
                }
              ]
            }
          ]
        }
      ]
    };
  },
  mounted() {}
};
</script>
